const language = {
    'pt': {
        photo: 'Carregar Foto de Perfil',
        noPhoto: 'Sem foto',
        overview: 'Visão Geral',
        naturalidade: 'Naturalidade',
        settings: 'Configurações',
        dados_fiscais: 'Dados Fiscais',
        contrato: 'Dados Contratuais',
        functions: 'Caracterização',
        departamentosEntidade: 'Elemento no(s) Departamento(s)',
        meus_dados: 'Meus dados',
        ações: 'Ações',
        add: 'Adicionar',
        add_new: 'Adicionar Nova Entidade',
        adicionar_departamento: 'Adicionar Departamento',
        adicionar_entidade: 'Adicionar Responsáveis',
        birthday: 'Data de nascimento',
        data_admissao: 'Data de Admissão',
        cancel: 'Cancelar', back: 'Voltar',
        carregar: 'Carregando Informações...',
        carregar_cv: 'Carregar CV',
        certificacao: 'Certificação em',
        city: 'Concelho',
        city_placeholder: 'Introduza a cidade',
        choose_profile: 'Escolha uma opção',
        close: 'Fechar',
        config: 'Configuração',
        contacto: 'Contacto',
        content: 'Conteúdo',
        content_edit: 'Editar conteúdo',
        content_list: 'Lista de conteúdos',
        content_new: 'Novo conteúdo',
        country: 'País',
        country_placeholder: 'Introduza o país',
        dark_mode: 'Dark mode',
        date_creation: 'Criação',
        date_last_update: 'Última actualização',
        date_publication: 'Publicação',
        dates: 'Datas',
        delete: 'Eliminar',
        delete_cancel: 'Não',
        delete_confirm: 'Sim',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_title: 'Eliminar Registo',
        departament: 'Dados Departamentais',
        departamento: 'Departamento',
        funcoes: 'Funções / Responsabilidades',
        identification: 'Identificação',
        dep_emp: 'Departamentos Empresariais e Certificações',
        description: 'Descrição',
        description_placeholder: 'Introduza uma descrição',
        detalhes_departamento: 'Detalhes do Departamento',
        detalhes_utilizador: 'Detalhes do Utilizador',
        district: 'Distrito',
        district_placeholder: 'Introduza o distrito',
        edit: 'Editar',
        edit_cancel: 'Não',
        edit_confirm: 'Sim',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_title: 'Editar Registo',
        email: 'E-mail',
        email_placeholder: 'Introduza o e-mail',
        entity: 'Entidade',
        entity_edit: 'Editar entidade',
        entity_externa: 'Entidades Externas',
        entity_interna: 'Entidades Internas',
        entity_list: 'Lista de entidades',
        entity_name: 'Username',
        entity_new: 'Novo entidade',
        entity_type: 'Tipo de Entidade',
        entity_nature: 'Natureza jurídica',
        entity_function: 'Função / Responsabilidade',
        function: 'Função',
        filter_placeholder: 'Procurar',
        id: 'ID',
        identification_number: 'Número de identificação',
        identification_number_placeholder: 'Introduza o número de identificação',
        identification_validation: 'Validade',
        image: 'Imagem',
        photo: 'Carregar Foto',
        noPhoto: 'Sem foto',
        image_choose: 'Escolher imagem',
        insert_cancel: 'Não',
        insert_confirm: 'Sim',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_title: 'Novo Registo',
        language: 'Lingua',
        local: 'Localidade',
        local_placeholder: 'Introduza a localidade',
        arquivo: 'Arquivo',
        arquivo_placeholder: 'Introduza local de arquivo',
        login_data: 'Dados de Login',
        morada: 'Morada',
        morada_placeholder: 'Introduza a morada',
        name: 'Nome',
        name_departamento: 'Nome do departamento',
        name_placeholder: 'Introduza o nome',
        no_departamento: 'Não há departamentos disponíveis',
        nome_responsavel: 'Nome do Responsável',
        password: 'Password',
        password_cancel: 'No',
        password_confirmation: 'Confirmação da Password',
        password_confirm: 'Continue',
        password_error: 'Problem inserting element!',
        password_placeholder: 'Introduza a password',
        password_success: 'Successful inserted element!',
        password_text: 'As Passwords não correspondem.',
        password_title: 'Password!',
        pdf_documents: 'Documentos PDF',
        pdf_documents_placeholder: 'Introduza o local do documento PDF',
        doc_choose: 'Escolher documento',
        personal_data: 'Dados Pessoais',
        postal_code: 'Código-postal',
        postal_code_placeholder: 'Introduza o código-postal',
        principal: 'Principal',
        profile: 'Perfil',
        razao_social: 'Razão Social',
        relacao: 'Tipo de Relação',
        remove: 'Remover',
        remove_cancel: 'Não',
        remove_confirm: 'Sim',
        remove_error: 'Problema ao remover o atributo!',
        remove_success: 'Registo removido com sucesso!',
        remove_text: 'Tem a certeza que pretende continuar?',
        remove_title: 'Remover atributo',
        responsaveis: 'Responsáveis',
        save: 'Salvar',
        save_entidade: 'Salvar Alterações',
        select: 'Selecione uma opção',
        selec_departamento: 'Selecione um departamento',
        table_actions: 'Acções',
        table_all: 'Todos',
        table_count: 'Count',
        table_date: 'Data',
        table_empty: 'Sem Resultados',
        table_parent: 'Parent',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_thumbnail: 'Thumbnail',
        table_title: 'Título',
        table_type: 'Tipo',
        text: 'Texto',
        title: 'Título',
        title_placeholder: 'Introduza o título',
        tlf: 'Telefone',
        tlf_placeholder: 'Introduza o número de telefone',
        tlm: 'Telemóvel',
        tlm_placeholder: 'Introduza o número de telemóvel',
        tipo: 'Tipo',
        type: 'Tipo de cliente',
        type_identification: 'Tipo de identificação',
        type_identification_placeholder: 'Introduza o tipo de identificação',
        type_placeholder: 'Introduza o tipo de cliente',
        username: 'Username',
        username_placeholder: 'Introduza o username',

        vat: 'NIF',
        vat_placeholder: 'Introduza o NIF',
        cae: 'CAE',
        cae_placeholder: 'Introduza o CAE',
        iban: 'IBAN',
        iban_placeholder: 'Introduza o IBAN',
        nbss: 'Nº Beneficiário da Segurança Social',
        nbss_placeholder: 'Introduza o Número de Beneficiário da Segurança Social',
        ass: 'Admissão da Segurança Social',
        ass_placeholder: 'Admissão da Segurança Social',

        contribuinte: 'BI / CC',
        contribuinte_placeholder: 'Introduza o BI / CC',
        validade_contribuinte: 'Validade do BI / CC',
        validade_contribuinte_placeholder: 'Introduza a validade do BI / CC',
        village: 'Freguesia',
        village_placeholder: 'Introduza a freguesia',
        warning_cancel: 'Não',
        warning_confirm: 'Continuar',
        warning_error: 'Problema ao inserir registo!',
        warning_success: 'Registo inserido com sucesso!',
        warning_text: 'O username já existe no sistema.',
        warning_title: 'Aviso!',
        tag: 'Alcunha',
        tag_placeholder: 'Introduza a alcunha',
        observacoes: 'Observações',

        horas_semanais: 'Horas Semanais',
        horas_semanais_placeholder: 'Introduza as Horas Semanais',
        seguro_acidente_trabalho: 'Seguro Acidente de Trabalho',
        seguro_acidente_trabalho_placeholder: 'Introduza o Seguro Acidente de Trabalho',

        genero: 'Genero',
        masculino: 'Masculino',
        feminino: 'Feminino',
        outro: 'Outro',

        estado_civil: 'Estado Civil',
        solteiro: 'Solteiro(a)',
        casado: 'Casado(a)',
        divorciado: 'Divorciado(a)',
        viuvo: 'Viúvo(a)',

        habilitacao_literaria: 'Habilitação Literária',
        ensino_basico: 'Ensino Básico',
        ensino_secundario: 'Ensino Secundário',
        licenciatura: 'Licenciatura',
        mestrado: 'Mestrado',
        doutoramento: 'Doutoramento',
        pos_doutoramento: 'Pós-Doutoramento',

        tipo_contrato: 'Tipo de Contrato',
        tipo_contrato_placeholder: 'Introduza o tipo de contrato',

        // Tipos de contrato:
        contrato_sem_termo: 'Contrato de trabalho sem termo (permanente ou efetivo)',
        contrato_termo_certo: 'Contrato de trabalho a termo certo (com duração definida)',
        contrato_termo_incerto: 'Contrato de trabalho a termo incerto (sem prazo final definido, mas com termo previsto por motivo justificado)',
        contrato_part_time: 'Contrato de trabalho a tempo parcial (part-time)',
        contrato_estagio: 'Contrato de estágio profissional',
        contrato_prestacao_servicos: 'Contrato de prestação de serviços (para trabalhadores independentes, com recibos verdes)',
        contrato_intermitente: 'Contrato de trabalho intermitente (trabalho por períodos intercalados)',

        // Dados desportivos
        dados_desportivos: 'Dados Desportivos',
        numero_atleta: 'Nº Atleta',
        numero_atleta_placeholder: 'Introduza o número de atleta',
        clube: 'Clube',
        clube_placeholder: 'Introduza o clube',
        escalao: 'Escalão',
        escalao_placeholder: 'Introduza o escalão',
        modalidades: 'Modalidade(s)',
        outras_modalidades: 'Outras Modalidades',
        modalidades_placeholder: 'Selecione a(s) modalidade(s)',

        // Categoria
        categoria: 'Categoria',
        alto_rendimento: 'Alto Rendimento',
        preparacao_olimpica: 'Preparação Olímpica',
        olimpico: 'Olímpico(a)',
        paralimpico: 'Paralímpico(a)',
        selecoes:  'Seleções', 

        // Deficiência
        deficiencia: 'Deficiência',
        sim: 'Sim',
        nao: 'Não',
        descricao: 'Descrição',

        // Tipo de prática desportiva
        tipo_pratica_desportiva: 'Tipo de Prática Desportiva',
        lazer: 'Lazer',
        competicao: 'Competição',

        // Programas
        programas: 'Programas',
       
        // Projetos
        projetos: 'Projetos',

        // Projeto P.A.I.S.
        projeto_pais: 'Projeto P.A.I.S.',
        projeto_pais_participa: 'Participa no Projeto P.A.I.S.',

        // Documentação associada
        documentacao_associada: 'Documentação Associada',
        exames_medicos: 'Exames Médicos',
        data_exame_medico: 'Data do Exame Médico',
        contratos: 'Contratos',
        seguro: 'Seguro',
        outros_documentos: 'Outros Documentos Pessoais',

        // Pais e Encarregados de Educação
        pais_encarregados: 'Pais e Encarregados de Educação',
        nome_contacto_pai: 'Nome e Contacto do Pai',
        nome_contacto_mae: 'Nome e Contacto da Mãe',
        nome_contacto_encarregado: 'Nome e Contacto do Encarregado de Educação',
        contacto_emergencia: 'Contacto de Emergência',

        // Ocupação
        ocupacao:       'Ocupação',
        empregado:      'Empregado',
        desempregado:   'Desempregado',
        estudante:      'Estudante',
        outro:          'Outro opção',

        tipo_entidade:      'Tipo de entidade',
        entidade_patronal:  'Entidade patronal',
        profissao:          'Profissão',
        entidade_publica:   'Pública',
        entidade_privada:   'Privada',
        entidade_militar:   'Militar',
        nome_escola:        'Nome da escola',
        ano_escolar:        'Ano que frequenta',
        turma_escolar:      'Turma',
        numero_escolar:     'Número de Estudante',
        area_escolar:       'Área',
        ocupacao_descricao: 'Especificar',

        select_all:         'Todos',
        select_inscritos:   'Inscritos em',


        // Uploads
        upload_file_error: 'Ficheiro inválido (apenas PDF até 10MB): ',
        upload_image_error: 'Imagem inválida (apenas imagens até 10MB): ',

        // Documento de identificação (info.identificacao)
        tipo_identificacao: 'Tipo de Identificação',
        cc: 'Cartão de Cidadão',
        passaporte: 'Passaporte',
        bi: 'Bilhete de Identidade',
        autorizacao_residencia: 'Autorização de Residência',
        numero_identificacao: 'Número de Identificação',
        numero_identificacao_placeholder: 'Introduza o número de identificação',
        validade_identificacao: 'Validade da Identificação',
        validade_identificacao_placeholder: 'Introduza a validade (MM/AA)',

        // Dados desportivos (extra)
        numero_licenca: 'Número de Licença',
        numero_licenca_placeholder: 'Introduza o número de licença',
        qualificacoes: 'Qualificações',
        qualificacoes_placeholder: 'Introduza as qualificações',

        // Documentação associada (extra)
        certificados: 'Certificados',
        licencas: 'Licenças',
        registo_criminal: 'Registo Criminal',

        numero: 'N.º Licença',

        
        pay_fee: 'Pagar inscrição',
        escalao:    'Escalão',

        cancel:                     'Cancelar',
        back:                       'Voltar',
        confirm_purchase_cancel:    'Cancelar finalização',
        confirm_purchase_confirm:   'Finalizar',
        confirm_purchase_error:     'Erro a processar a inscrição.',
        confirm_purchase_success:   'Inscrição processada com sucesso.',
        confirm_purchase_text:      'Pretende finalizar a inscrição?',
        confirm_purchase_title:     'Confirmar inscrição',

        confirm_login_error:        'O registo é obrigatório.',
        confirm_form_error:         'Os campos assinalados com (*) são de preenchimento obrigatório. O endereço de email permite um contacto mais rápido em caso de necessidade de esclarecimentos adicionais. A informação que submeter não será usada ou distribuída por outra razão que não o processamento do seu pedido.',
        confirm_agree_error:        'Tem de ler e aceitar os termos e condições para finalizar a compra.',

        encomenda_finalizada:       'Inscrição registada com sucesso!',
        encomenda_finalizada_attention: 'Atenção',
        encomenda_finalizada_attention_txt: 'O email pode ir para SPAM.',
        encomenda_finalizada_free:  'Inscrição registada com sucesso!',

        dados_tipo_pagamento:       'Tipo de pagamento',
        valor_a_pagar:              'Valor a pagar',

        tb_iban:                    'IBAN',
        tb_attention:               'Atenção',
        tb_details:                 'Na descrição da tranferência deve constar o nome do atleta.',


        ski_de_fundo: 'Esqui de Fundo',
        curling: 'Curling',
        ski_alpino: 'Esqui Alpino',
        bobsled: 'Bobsled',
        hoquei_no_gelo: 'Hóquei no Gelo',
        luge: 'Luge',
        snowboard: 'Snowboard',
        skeleton: 'Skeleton',
        patinagem_artistica: 'Patinagem Artística',
        patinagem_de_velocidade: 'Patinagem de Velocidade',
        ski_freestyle: 'Esqui Freestyle',
        biatlo: 'Biatlo',

    },

    'en': {
        photo: 'Load Profile Photo',
        noPhoto: 'No photo',
        overview: 'Overview',
        naturalidade: 'Naturalness',
        settings: 'Settings',
        dados_fiscais: 'Fiscal Data',
        contrato: 'Contract Data',
        functions: 'Caraterization',
        departamentosEntidade: 'Element in Department(s)',
        tag: 'Tag',
        tag_placeholder: 'Insert tag',
        pdf_documents: 'PDF Documents',
        pdf_documents_placeholder: 'Enter the PDF document location',
        doc_choose: 'Choose document',
        meus_dados: 'Personal data',
        ações: 'Actions',
        add: 'Add',
        add_new: 'Add New Entity',
        adicionar_departamento: 'Add Department',
        adicionar_entidade: 'Add Responsible Parties',
        birthday: 'Date of birth',
        data_admissao: 'Admission Date',
        cancel: 'Cancel',
        carregar: 'Loading Information...',
        carregar_cv: 'Load CV',
        certificacao: 'Certificate on',
        city: 'Municipality',
        city_placeholder: 'Enter the municipality',
        choose_profile: 'Choose an option',
        close: 'Close',
        config: 'Configuration',
        contacto: 'Contact',
        content: 'Content',
        content_edit: 'Edit content',
        content_list: 'Content list',
        content_new: 'New content',
        country: 'Country',
        country_placeholder: 'Enter the country',
        dark_mode: 'Dark mode',
        date_creation: 'Creation',
        date_last_update: 'Last update',
        date_publication: 'Publication',
        dates: 'Dates',
        delete: 'Delete',
        delete_cancel: 'No',
        delete_confirm: 'Yes',
        delete_error: 'Error deleting record!',
        delete_success: 'Record deleted successfully!',
        delete_text: 'Are you sure you want to proceed?',
        delete_title: 'Delete Record',
        departament: 'Departmental Data',
        departamento: 'Department',
        funcoes: 'Functions / Responsibilities',
        identification: 'Identification',
        dep_emp: 'Business Departments and Certifications',
        description: 'Description',
        description_placeholder: 'Enter a description',
        detalhes_departamento: 'Department Details',
        detalhes_utilizador: 'User Details',
        district: 'District',
        district_placeholder: 'Enter the district',
        edit: 'Edit',
        edit_cancel: 'No',
        edit_confirm: 'Yes',
        edit_error: 'Error updating record!',
        edit_success: 'Record updated successfully!',
        edit_text: 'Are you sure you want to proceed?',
        edit_title: 'Edit Record',
        email: 'Email',
        email_placeholder: 'Enter the email',
        entity: 'Entity',
        entity_edit: 'Edit entity',
        entity_externa: 'External Entities',
        entity_interna: 'Internal Entities',
        entity_list: 'Entity list',
        entity_name: 'Username',
        entity_new: 'New entity',
        entity_type: 'Entity Type',
        entity_nature: 'Natureza jurídica',
        entity_function: 'Function / Responsability',
        filter_placeholder: 'Search',
        id: 'ID',
        identification_number: 'Identification number',
        identification_number_placeholder: 'Enter the identification number',
        identification_validation: 'Validation',
        photo: 'Load Profile Photo',
        noPhoto: 'No photo',
        image: 'Image',
        image_choose: 'Choose image',
        insert_cancel: 'No',
        insert_confirm: 'Yes',
        insert_error: 'Error inserting record!',
        insert_success: 'Record inserted successfully!',
        insert_text: 'Are you sure you want to proceed?',
        insert_title: 'New Record',
        language: 'Language',
        local: 'Locality',
        local_placeholder: 'Enter the locality',
        login_data: 'Login Data',
        morada: 'Address',
        morada_placeholder: 'Enter the address',
        name: 'Name',
        name_departamento: 'Department name',
        name_placeholder: 'Enter the name',
        no_departamento: 'No departments available',
        nome_responsavel: 'Responsible Party Name',
        password: 'Password',
        password_cancel: 'No',
        password_confirmation: 'Password Confirmation',
        password_confirm: 'Continue',
        password_error: 'Error inserting element!',
        password_placeholder: 'Enter the password',
        password_success: 'Element inserted successfully!',
        password_text: 'Passwords do not match.',
        password_title: 'Password!',
        personal_data: 'Personal Data',
        postal_code: 'Postal code',
        postal_code_placeholder: 'Enter the postal code',
        principal: 'Principal',
        profile: 'Profile',
        razao_social: 'Corporate Name',
        relacao: 'Relationship Type',
        remove: 'Remove',
        responsaveis: 'Responsible Parties',
        save: 'Save',
        save_entidade: 'Save Changes',
        select: 'Select an option',
        selec_departamento: 'Select a department',
        table_actions: 'Actions',
        table_all: 'All',
        table_count: 'Count',
        table_date: 'Date',
        table_empty: 'No Results',
        table_parent: 'Parent',
        table_rows_per_page: 'Records per page:',
        table_separator: 'of',
        table_state: 'State',
        table_thumbnail: 'Thumbnail',
        table_title: 'Title',
        table_type: 'Type',
        text: 'Text',
        title: 'Title',
        title_placeholder: 'Enter the title',
        tlf: 'Phone',
        tlf_placeholder: 'Enter the phone number',
        tlm: 'Mobile',
        tlm_placeholder: 'Enter the mobile number',
        tipo: 'Type',
        type: 'Client type',
        type_identification: 'Identification type',
        type_identification_placeholder: 'Enter the identification type',
        type_placeholder: 'Enter the client type',
        username: 'Username',
        username_placeholder: 'Enter the username',

        vat: 'VAT',
        vat_placeholder: 'Enter the VAT',
        cae: 'CAE',
        cae_placeholder: 'Enter the CAE',
        ibr: 'IBAN',
        ibr_placeholder: 'Enter the IBAN',
        nbss: 'Social Security Beneficiary Number',
        nbss_placeholder: 'Enter the Social Security Beneficiary Number',
        ass: 'Social Security Admission',
        ass_placeholder: 'Enter the Social Security Admission',

        contribuinte: 'BI / CC',
        contribuinte_placeholder: 'Enter the BI / CC',
        validade_contribuinte: 'BI / CC Validity',
        validade_contribuinte_placeholder: 'Enter the BI / CC validity',
        village: 'Parish',
        village_placeholder: 'Enter the parish',
        warning_cancel: 'No',
        warning_confirm: 'Continue',
        warning_error: 'Error inserting record!',
        warning_success: 'Record inserted successfully!',
        warning_text: 'The username already exists in the system.',
        warning_title: 'Warning!',
        observacoes: 'Observations',

        genero: 'Gender',
        masculino: 'male',
        feminino: 'female',
        outro: 'other',

        estado_civil: 'Marital Status',
        solteiro: 'single',
        casado: 'married',
        divorciado: 'divorced',
        viuvo: 'widowed',

        habilitacao_literaria: 'Literary Qualification',
        ensino_basico: 'Basic Education',
        ensino_secundario: 'Secondary Education',
        licenciatura: 'Bachelor\'s Degree',
        mestrado: 'Master\'s Degree',
        doutoramento: 'PhD',
        pos_doutoramento: 'Postdoctoral',


        horas_semanais: 'Weekly Hours',
        horas_semanais_placeholder: 'Enter Weekly Hours',
        seguro_acidente_trabalho: 'Work Accident Insurance',
        seguro_acidente_trabalho_placeholder: 'Enter Work Accident Insurance',

        tipo_contrato: 'Contract Type',
        tipo_contrato_placeholder: 'Enter the contract type',

        // Contract types:
        contrato_sem_termo: 'Permanent employment contract (indefinite or effective)',
        contrato_termo_certo: 'Fixed-term employment contract (with defined duration)',
        contrato_termo_incerto: 'Indefinite-term employment contract (without final deadline but with expected term for justified reason)',
        contrato_part_time: 'Part-time employment contract',
        contrato_estagio: 'Professional internship contract',
        contrato_prestacao_servicos: 'Service provision contract (for self-employed workers, with green receipts)',
        contrato_intermitente: 'Intermittent employment contract (work in alternating periods)',

        back: 'Back',
        arquivo: 'Archive',
        arquivo_placeholder: 'Enter the archive location',
        iban: 'IBAN',
        iban_placeholder: 'Enter the IBAN',

        remove_title: 'Remove Attribute',
        remove_text: 'Are you sure you want to proceed?',
        remove_confirm: 'Yes',
        remove_cancel: 'No',

        // Sports data
        dados_desportivos: 'Sports Data',
        numero_atleta: 'Athlete Number',
        numero_atleta_placeholder: 'Enter the athlete number',
        clube: 'Club',
        clube_placeholder: 'Enter the club',
        escalao: 'Age Group',
        escalao_placeholder: 'Enter the age group',
        modalidades: 'Sport(s)',
        modalidades_placeholder: 'Select the sport(s)',

        // Category
        categoria: 'Category',
        alto_rendimento: 'High Performance',
        preparacao_olimpica: 'Olympic Preparation',
        olimpico: 'Olympic',

        // Disability
        deficiencia: 'Disability',
        sim: 'Yes',
        nao: 'No',
        descricao: 'Description',

        // Type of sports practice
        tipo_pratica_desportiva: 'Type of Sports Practice',
        lazer: 'Leisure',
        competicao: 'Competition',

        // Programs
        programas: 'Programs',

        // P.A.I.S. Project
        projeto_pais: 'P.A.I.S. Project',
        projeto_pais_participa: 'Participates in the P.A.I.S. Project',

        // Associated documentation
        documentacao_associada: 'Associated Documentation',
        exames_medicos: 'Medical Exams',
        data_exame_medico: 'Medical Exam Date',
        contratos: 'Contracts',
        seguro: 'Insurance',
        outros_documentos: 'Other Personal Documents',

        // Parents and Guardians
        pais_encarregados: 'Parents and Guardians',
        nome_contacto_pai: 'Father Name and Contact',
        nome_contacto_mae: 'Mother Name and Contact',
        nome_contacto_encarregado: 'Guardian Name and Contact',
        contacto_emergencia: 'Emergency Contact',

        // Uploads
        upload_file_error: 'Invalid file (PDF only, up to 10MB): ',
        upload_image_error: 'Invalid image (up to 10MB): ',

        // Identification document (info.identificacao)
        tipo_identificacao: 'Identification Type',
        cartao_cidadao: 'Citizen Card',
        passaporte: 'Passport',
        numero_identificacao: 'Identification Number',
        numero_identificacao_placeholder: 'Enter the identification number',
        validade_identificacao: 'Identification Validity',
        validade_identificacao_placeholder: 'Enter the validity (MM/YY)',

        // Sports data (extra)
        numero_licenca: 'License Number',
        numero_licenca_placeholder: 'Enter the license number',
        qualificacoes: 'Qualifications',
        qualificacoes_placeholder: 'Enter the qualifications',

        // Associated documentation (extra)
        certificados: 'Certificates',
        licencas: 'Licenses',
        registo_criminal: 'Criminal Record',

        numero: 'N.º Licença',
    },
    'es': {
        ações: 'Acciones',
        add: 'Añadir',
        add_new: 'Añadir nuevo',
        adicionar_departamento: 'Añadir Departamento',
        adicionar_entidade: 'Añadir Responsables',
        birthday: 'Fecha de nacimiento',
        cancel: 'Cancelar', back: 'Voltar',
        carregar: 'Cargando Información...',
        city: 'Municipio',
        city_placeholder: 'Introduce el municipio',
        choose_profile: 'Elige una opción',
        close: 'Cerrar',
        config: 'Configuración',
        contacto: 'Contacto',
        content: 'Contenido',
        content_edit: 'Editar contenido',
        content_list: 'Lista de contenidos',
        content_new: 'Nuevo contenido',
        country: 'País',
        country_placeholder: 'Introduce el país',
        dark_mode: 'Modo oscuro',
        date_creation: 'Creación',
        date_last_update: 'Última actualización',
        date_publication: 'Publicación',
        dates: 'Fechas',
        delete: 'Eliminar',
        delete_cancel: 'No',
        delete_confirm: 'Sí',
        delete_error: '¡Error al eliminar el registro!',
        delete_success: '¡Registro eliminado con éxito!',
        delete_text: '¿Está seguro de que desea continuar?',
        delete_title: 'Eliminar Registro',
        departament: 'Datos Departamentales',
        departamento: 'Departamento',
        dep_emp: 'Departamentos Empresariales y Certificaciones',
        description: 'Descripción',
        description_placeholder: 'Introduce una descripción',
        detalhes_departamento: 'Detalles del Departamento',
        detalhes_utilizador: 'Detalles del Usuario',
        district: 'Distrito',
        district_placeholder: 'Introduce el distrito',
        edit: 'Editar',
        edit_cancel: 'No',
        edit_confirm: 'Sí',
        edit_error: '¡Error al actualizar el registro!',
        edit_success: '¡Registro actualizado con éxito!',
        edit_text: '¿Está seguro de que desea continuar?',
        edit_title: 'Editar Registro',
        email: 'Correo electrónico',
        email_placeholder: 'Introduce el correo electrónico',
        entity: 'Entidad',
        entity_edit: 'Editar entidad',
        entity_externa: 'Entidades Externas',
        entity_interna: 'Entidades Internas',
        entity_list: 'Lista de entidades',
        entity_name: 'Username',
        entity_new: 'Nueva entidad',
        entity_type: 'Tipo de Entidad',
        entity_nature: 'Natureza jurídica',
        entity_function: 'Função / Responsabilidade',
        filter_placeholder: 'Buscar',
        id: 'ID',
        identification_number: 'Número de identificación',
        identification_number_placeholder: 'Introduce el número de identificación',
        identification_validation: 'Validación',
        image: 'Imagen',
        image_choose: 'Elegir imagen',
        insert_cancel: 'No',
        insert_confirm: 'Sí',
        insert_error: '¡Error al insertar el registro!',
        insert_success: '¡Registro insertado con éxito!',
        insert_text: '¿Está seguro de que desea continuar?',
        insert_title: 'Nuevo Registro',
        language: 'Idioma',
        local: 'Localidad',
        local_placeholder: 'Introduce la localidad',
        login_data: 'Datos de Inicio de Sesión',
        morada: 'Dirección',
        morada_placeholder: 'Introduce la dirección',
        name: 'Nombre',
        name_departamento: 'Nombre del departamento',
        name_placeholder: 'Introduce el nombre',
        no_departamento: 'No hay departamentos disponibles',
        nome_responsavel: 'Nombre del Responsable',
        password: 'Contraseña',
        password_cancel: 'No',
        password_confirmation: 'Confirmación de la Contraseña',
        password_confirm: 'Continuar',
        password_error: '¡Error al insertar el elemento!',
        password_placeholder: 'Introduce la contraseña',
        password_success: '¡Elemento insertado con éxito!',
        password_text: 'Las contraseñas no coinciden.',
        password_title: '¡Contraseña!',
        personal_data: 'Datos Personales',
        postal_code: 'Código postal',
        postal_code_placeholder: 'Introduce el código postal',
        principal: 'Principal',
        profile: 'Perfil',
        razao_social: 'Razón Social',
        relacao: 'Tipo de Relación',
        remove: 'Eliminar',
        responsaveis: 'Responsables',
        save: 'Guardar',
        save_entidade: 'Guardar Cambios',
        select: 'Seleccione una opción',
        selec_departamento: 'Seleccione un departamento',
        table_actions: 'Acciones',
        table_all: 'Todos',
        table_count: 'Cantidad',
        table_date: 'Fecha',
        table_empty: 'Sin Resultados',
        table_parent: 'Padre',
        table_rows_per_page: 'Registros por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_thumbnail: 'Miniatura',
        table_title: 'Título',
        table_type: 'Tipo',
        text: 'Texto',
        title: 'Título',
        title_placeholder: 'Introduce el título',
        tlf: 'Teléfono',
        tlf_placeholder: 'Introduce el número de teléfono',
        tlm: 'Móvil',
        tlm_placeholder: 'Introduce el número de móvil',
        tipo: 'Tipo',
        type: 'Tipo de cliente',
        type_identification: 'Tipo de identificación',
        type_identification_placeholder: 'Introduce el tipo de identificación',
        type_placeholder: 'Introduce el tipo de cliente',
        username: 'Nombre de usuario',
        username_placeholder: 'Introduce el nombre de usuario',
        vat: 'NIF',
        vat_placeholder: 'Introduce el NIF',
        cae: 'CAE',
        cae_placeholder: 'Introduce el CAE',
        village: 'Parroquia',
        village_placeholder: 'Introduce la parroquia',
        warning_cancel: 'No',
        warning_confirm: 'Continuar',
        warning_error: '¡Error al insertar el registro!',
        warning_success: '¡Registro insertado con éxito!',
        warning_text: 'El nombre de usuario ya existe en el sistema.',
        warning_title: '¡Advertencia!',

        photo: 'Cargar Foto',
        noPhoto: 'Sin foto',
        arquivo: 'Archivo',
        arquivo_placeholder: 'Introduce la ubicación del archivo',
        carregar_cv: 'Cargar CV',
        doc_choose: 'Elegir documento',
        certificacao: 'Certificación en',
        observacoes: 'Observaciones',

        data_admissao: 'Fecha de Admisión',
        horas_semanais: 'Horas Semanales',
        horas_semanais_placeholder: 'Introduce las Horas Semanales',
        seguro_acidente_trabalho: 'Seguro de Accidentes de Trabajo',
        seguro_acidente_trabalho_placeholder: 'Introduce el Seguro de Accidentes de Trabajo',

        genero: 'Género',
        masculino: 'Masculino',
        feminino: 'Femenino',
        outro: 'Otro',

        estado_civil: 'Estado Civil',
        solteiro: 'Soltero(a)',
        casado: 'Casado(a)',
        divorciado: 'Divorciado(a)',
        viuvo: 'Viudo(a)',

        habilitacao_literaria: 'Nivel de Estudios',
        ensino_basico: 'Educación Básica',
        ensino_secundario: 'Educación Secundaria',
        licenciatura: 'Licenciatura',
        mestrado: 'Máster',
        doutoramento: 'Doctorado',
        pos_doutoramento: 'Posdoctorado',

        tipo_contrato: 'Tipo de Contrato',
        tipo_contrato_placeholder: 'Introduce el tipo de contrato',
        contrato_sem_termo: 'Contrato de trabajo indefinido (permanente)',
        contrato_termo_certo: 'Contrato de trabajo de duración determinada',
        contrato_termo_incerto: 'Contrato de trabajo de duración incierta (sin plazo final definido, pero con término previsto por motivo justificado)',
        contrato_part_time: 'Contrato de trabajo a tiempo parcial',
        contrato_estagio: 'Contrato de prácticas profesionales',
        contrato_prestacao_servicos: 'Contrato de prestación de servicios (para trabajadores autónomos)',
        contrato_intermitente: 'Contrato de trabajo intermitente (trabajo por períodos alternos)',

        iban: 'IBAN',
        iban_placeholder: 'Introduce el IBAN',
        nbss: 'Nº de Beneficiario de la Seguridad Social',
        nbss_placeholder: 'Introduce el Número de Beneficiario de la Seguridad Social',
        ass: 'Admisión de la Seguridad Social',
        ass_placeholder: 'Admisión de la Seguridad Social',

        contribuinte: 'DNI / NIE',
        contribuinte_placeholder: 'Introduce el DNI / NIE',
        validade_contribuinte: 'Validez del DNI / NIE',
        validade_contribuinte_placeholder: 'Introduce la validez del DNI / NIE',

        remove_title: 'Eliminar atributo',
        remove_text: '¿Está seguro de que desea continuar?',
        remove_confirm: 'Sí',
        remove_cancel: 'No',

        // Datos deportivos
        dados_desportivos: 'Datos Deportivos',
        numero_atleta: 'Nº de Atleta',
        numero_atleta_placeholder: 'Introduce el número de atleta',
        clube: 'Club',
        clube_placeholder: 'Introduce el club',
        escalao: 'Categoría de Edad',
        escalao_placeholder: 'Introduce la categoría de edad',
        modalidades: 'Modalidad(es)',
        modalidades_placeholder: 'Selecciona la(s) modalidad(es)',

        // Categoría
        categoria: 'Categoría',
        alto_rendimento: 'Alto Rendimiento',
        preparacao_olimpica: 'Preparación Olímpica',
        olimpico: 'Olímpico(a)',

        // Discapacidad
        deficiencia: 'Discapacidad',
        sim: 'Sí',
        nao: 'No',
        descricao: 'Descripción',

        // Tipo de práctica deportiva
        tipo_pratica_desportiva: 'Tipo de Práctica Deportiva',
        lazer: 'Ocio',
        competicao: 'Competición',

        // Programas
        programas: 'Programas',

        // Proyecto P.A.I.S.
        projeto_pais: 'Proyecto P.A.I.S.',
        projeto_pais_participa: 'Participa en el Proyecto P.A.I.S.',

        // Documentación asociada
        documentacao_associada: 'Documentación Asociada',
        exames_medicos: 'Exámenes Médicos',
        data_exame_medico: 'Fecha del Examen Médico',
        contratos: 'Contratos',
        seguro: 'Seguro',
        outros_documentos: 'Otros Documentos Personales',

        // Padres y Tutores
        pais_encarregados: 'Padres y Tutores',
        nome_contacto_pai: 'Nombre y Contacto del Padre',
        nome_contacto_mae: 'Nombre y Contacto de la Madre',
        nome_contacto_encarregado: 'Nombre y Contacto del Tutor',
        contacto_emergencia: 'Contacto de Emergencia',

        // Subidas de archivos
        upload_file_error: 'Archivo no válido (solo PDF, hasta 10MB): ',
        upload_image_error: 'Imagen no válida (hasta 10MB): ',

        // Etiquetas de separadores (que faltaban en este idioma)
        naturalidade: 'Naturalidad',
        dados_fiscais: 'Datos Fiscales',
        contrato: 'Datos Contractuales',
        functions: 'Caracterización',
        settings: 'Configuración',

        // Documento de identificación (info.identificacao)
        tipo_identificacao: 'Tipo de Identificación',
        cartao_cidadao: 'Tarjeta de Ciudadano',
        passaporte: 'Pasaporte',
        numero_identificacao: 'Número de Identificación',
        numero_identificacao_placeholder: 'Introduce el número de identificación',
        validade_identificacao: 'Validez de la Identificación',
        validade_identificacao_placeholder: 'Introduce la validez (MM/AA)',

        // Datos deportivos (extra)
        numero_licenca: 'Número de Licencia',
        numero_licenca_placeholder: 'Introduce el número de licencia',
        qualificacoes: 'Cualificaciones',
        qualificacoes_placeholder: 'Introduce las cualificaciones',

        // Documentación asociada (extra)
        certificados: 'Certificados',
        licencas: 'Licencias',
        registo_criminal: 'Antecedentes Penales',

        numero: 'N.º Licença',
    },
}

module.exports = {
    language
};